import { format } from 'date-fns';

import { EventDetails } from '../types';

export const getDefaultValues = (details: EventDetails) => {
  if (!details) return {};

  return {
    ...details,
    aiModel: details?.aiModel || '',
    masks: (details?.masks ?? []).map((mask) => ({
      maskId: mask.id,
      overlayId: mask.overlays?.[0]?.id ?? '',
    })),
    lacesColors: (details?.lacesColors ?? []).map(
      ({ id, name, hex, quantity }) => ({
        id,
        name,
        hex,
        quantity,
      })
    ),
    collarColors: (details?.collarColors ?? []).map(({ id, name, hex }) => ({
      id,
      name,
      hex,
    })),
    publicUrl: details?.publicUrl || '',
    idleStateVideoPublicUrl: details?.idleStateVideoPublicUrl || '',
    backgroundImageUrl: details?.backgroundImageFileObject?.readUrl || '',
    styles: (details?.styles ?? []).map((style) => ({
      styleId: style.id,
      imagePublicUrl: style.fileObject?.readUrl ?? '',
    })),
    textStyles: (details?.textStyles ?? []).map((textStyle) => ({ textStyleId: textStyle.id })),
    updatedAt: details?.startDate
      ? format(new Date(details?.startDate), 'yyyy-MM-dd')
      : '',
    models: (details?.models ?? []).map((modelDetails) => {
      const { model, sides, sizes } = modelDetails;

      return {
        modelId: model.id,
        typeId: model.type.id,
        genderId: model.gender.id,
        name: model.name,
        position: [...sides],
        sizes: sizes.map((size) => ({
          sizeId: size.size.id,
          value: size.size.value,
          colorId: model.color.id,
          quantity: size.quantity,
          reservedQuantity: size.reservedQuantity,
        })),
      };
    }),
    types: (details?.types ?? []).map((type) => type.id),
    remixingEnabled: details?.featureFlags?.remixingEnabled ?? false,
    groupOrderingEnabled: details?.featureFlags?.groupOrderingEnabled ?? false,
    isGeneratedImageCodeEnabled: details?.featureFlags?.isGeneratedImageCodeEnabled ?? false,
    isPromoSmsEnabled: details?.featureFlags?.isPromoSmsEnabled ?? false,
    surpriseMeEnabled: details?.featureFlags?.surpriseMeEnabled ?? false,
    rectangleImageGenerationEnabled: details?.featureFlags?.rectangleImageGenerationEnabled ?? false,
    isFadedHeelEnabled: details?.featureFlags?.isFadedHeelEnabled ?? false,
    isShoeSizeHintEnabled: details?.featureFlags?.isShoeSizeHintEnabled ?? false,
    gptEnabled: details?.featureFlags?.gptEnabled ?? false,
    signatureEnabled: details?.featureFlags?.signatureEnabled ?? false,
    systemPromptCategoryId: '',
    systemPromptId: details?.eventSystemPrompt?.systemPromptId ?? '',
    systemPromptContent: details?.eventSystemPrompt?.content ?? '',
    systemPromptSurpriseMeContent: details?.eventSystemPrompt?.surpriseMeContent ?? '',
    systemPromptNotes: details?.eventSystemPrompt?.notes ?? '',
    securityPrompt: details?.securityPrompt ?? '',
  };
};
